var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 0.75,
    viewBox: "0 0 10 0.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5496",
    "data-name": "Group 5496",
    transform: "translate(-1328 -320.625)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "plus_line_1",
    "data-name": "plus line 1",
    y2: 10,
    transform: "translate(1338 321) rotate(90)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.75
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMinus);
export default __webpack_public_path__ + "static/media/mobile-minus.4abe4bbc44eba8e5d1cb2f8043d062c2.svg";
export { ForwardRef as ReactComponent };